// extracted by mini-css-extract-plugin
export default {"title":"styles__title___2LfIp","header":"styles__header___KVb+R"};